// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1zfLa","errors":"Errors_errors__cOH0j"};